"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.join");

require("core-js/modules/es.array.map");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.string.replace");

require("core-js/modules/es.string.starts-with");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useRouteBuilder;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var joinPath = function joinPath() {
  for (var _len = arguments.length, fr = new Array(_len), _key = 0; _key < _len; _key++) {
    fr[_key] = arguments[_key];
  }

  return (fr || []).join('/').replace(/\/+/g, '/');
};
/**
 * Hook vraci funkci builderu location cesty. Hook akceptuje parametrizovatelne fragmenty cest, ze kterych sestavy
 * template cety. Vstupem do builderu jsou pak parametry, ktere jsou aplikovany na template. Pri aplikaci jsou hodnoty
 * parametru encodovany pomoci `encodeURIComponent` s vyjimkou hodnot typu `string` zacinajicich `:`.
 *
 * Builder se da pouzit i na sestaveni dalsich parametrizovanych templatu. Pokud hodnota parametru je `string`
 * zacinajici `:` parametr bube ponechan bezezmeny, nebude encodovan.
 *
 * @param  {...string} pathFragments
 *
 * @returns {function} `(params?: { [paramName]: string }) => string`
 */


function useRouteBuilder() {
  for (var _len2 = arguments.length, pathFragments = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    pathFragments[_key2] = arguments[_key2];
  }

  return (0, _react.useCallback)(function () {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Object.keys(params).map(function (key) {
      return [":".concat(key), typeof params[key] === 'string' && params[key].startsWith(':') ? params[key] : encodeURIComponent(params[key])];
    }).reduce(function (ret, _ref) {
      var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
          f = _ref2[0],
          r = _ref2[1];

      return ret.replace(f, r);
    }, joinPath.apply(void 0, pathFragments)).replace(/\/+/g, '/').replace(/\/$/g, '');
  }, [pathFragments]);
}